import React from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { RecognitionTickIcon } from '../../utils/icons';
import { Border } from '../RecogntionAdmin/styles';
import useOutsideClick from '../../hooks/useOutSideClick';
import { CommonDeptLocContainer, CheckBoxContainer } from '../common/CommonDeptLoc/style';

const BirthdayAnniversaryFilter = ({/*companyId,*/selectedDepartments, selectedLocations, locationData, departmentData, isDropdownOpen/*,hidePopup*/, onSelectDepartment, onSelectLocation, setIsDropdownOpen, handleSelectedLocations, handleSelectedDepartments }) => {
  const ref = useOutsideClick(() => {
    setIsDropdownOpen();
  });

  const toggleSelection = (list, id) => list.includes(id)

    ? list.filter((item) => item !== id)
    : [...list, id];

  const SelectDepartment = (id) => {
    const updated = toggleSelection(selectedDepartments, id);
    handleSelectedDepartments(updated);
    if (onSelectDepartment) {
      const label = departmentData.find((d) => d.id === id)?.department || '';
      const isSelected = updated.includes(id);
      onSelectDepartment(updated, label, isSelected);
    }
  };

  const SelectLocation = (id) => {
    const updated = toggleSelection(selectedLocations, id);
    handleSelectedLocations(updated);
    if (onSelectLocation) {
      const label = locationData.find((l) => l.id === id)?.location || '';
      const isSelected = updated.includes(id);
      onSelectLocation(updated, label, isSelected);
    }
  };

  const selectAllDepartments = () => {
    if (selectedDepartments.length === departmentData?.length) {
      handleSelectedDepartments([]);
      if (onSelectDepartment) {
        onSelectDepartment([], '', false);
      }
    } else {
      const allIds = departmentData.map((dep) => dep.id);
      handleSelectedDepartments(allIds);
      if (onSelectDepartment) {
        onSelectDepartment(allIds, 'All Departments', true);
      }
    }
  };

  const selectAllLocations = () => {
    if (selectedLocations.length === locationData?.length) {
      handleSelectedLocations([]);
      if (onSelectLocation) {
        onSelectLocation([], '', false);
      }
    } else {
      const allIds = locationData.map((loc) => loc.id);
      handleSelectedLocations(allIds);
      if (onSelectLocation) {
        onSelectLocation(allIds, 'All Locations', true);
      }
    }
  };



  return (
    <>{isDropdownOpen ?
      <CommonDeptLocContainer  ref={ref} isTop={"109px"} isRight={"39px"} isHeight={"400px"}>
        <div className='dept-loc-conteiner'>
          {departmentData.length ? <div className="all-department">
            <div className="department-title">
              <CheckBoxContainer selected={selectedDepartments.length === departmentData.length ? true : false} onClick={() => selectAllDepartments()}>
                <div className="archive-action">{selectedDepartments.length === departmentData.length ? RecognitionTickIcon() : null}</div>
              </CheckBoxContainer>
              <span className='dept-name'>All Departments</span>
            </div>
            <Border style={{ border: "1px solid #EFEFEF", margin: "8px 0px" }} />
            <div className="department-list">
              {departmentData.map((department, index) => (
                <div key={index + department.id} className="department-row" onClick={() => SelectDepartment(department.id)}>
                  <CheckBoxContainer selected={selectedDepartments.includes(department.id) ? true : false}>
                    <div className="archive-action" >{selectedDepartments.includes(department.id) ? RecognitionTickIcon() : null}</div>
                  </CheckBoxContainer>
                  <span className='dept-name'>{department.department}</span>
                </div>
              ))}
            </div>
          </div> : null}
          {locationData.length ? <div className="all-location">
            <div className="department-title">
              <CheckBoxContainer selected={selectedLocations.length === locationData.length ? true : false} onClick={() => selectAllLocations()}>
                <div className="archive-action" >{selectedLocations.length === locationData.length ? RecognitionTickIcon() : null}</div>
              </CheckBoxContainer>
              <span className='dept-name'>All Locations</span>
            </div>
            <Border style={{ border: "1px solid #EFEFEF", margin: "8px 0px" }} />
            <div className="department-list">
              {locationData.map((location, index) => (
                <div key={index + location.id} className="department-row" onClick={() => SelectLocation(location.id)}>
                  <CheckBoxContainer selected={selectedLocations.includes(location.id) ? true : false}>
                    <div className="archive-action">{selectedLocations.includes(location.id) ? RecognitionTickIcon() : null}</div>
                  </CheckBoxContainer>
                  <span className='dept-name'>{location.location}</span>
                </div>
              ))}
            </div></div> : null}</div>
      </CommonDeptLocContainer>
      : null}</>
  )
}

BirthdayAnniversaryFilter.propTypes = {
  isDropdownOpen: PropTypes.bool,
  fetchCelebrationsDetails: PropTypes.func,
  companyId: PropTypes.number,
  departmentData: PropTypes.array,
  locationData: PropTypes.array,
  hidePopup: PropTypes.func,
  onSelectDepartment: PropTypes.func,
  onSelectLocation: PropTypes.func,
  setIsDropdownOpen: PropTypes.func,
  selectedLocations: PropTypes.array,
  selectedDepartments: PropTypes.array,
  handleSelectedDepartments: PropTypes.func,
  handleSelectedLocations: PropTypes.func,
}

const mapStateToProps = (state) => ({
  departmentDetails: state.companyDashboard.companyPeopleDepartment,
  locationDetails: state.companyDashboard.companyPeopleLocation,

})

export default connect(mapStateToProps, null)((BirthdayAnniversaryFilter));



